import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { StyledModalHeader } from '../styled';

import FreeDeliveryMessage from './free-delivery-message';

const StyledLovedOnesModalHeader = styled(StyledModalHeader)`
  ${Styles.mobile`
    font-size: 1.6rem;
  `}
`;

const DeliveryAddressFormHeader = () => {
  const isLovedOnesMsg = useFlag(LaunchDarklyFlag.ENABLE_LOVED_ONES_DELIVERY_ADDRESS_TEXT);
  const enableSimplifiedDelivery = useFlag(LaunchDarklyFlag.ENABLE_SIMPLE_DELIVERY_FORM);
  const deliveryFormCTA = useFlag(LaunchDarklyFlag.DELIVERY_FORM_CTA);

  const showFreeDeliveryBanner = enableSimplifiedDelivery && deliveryFormCTA;
  const { formatMessage } = useIntl();

  return (
    <>
      {showFreeDeliveryBanner && <FreeDeliveryMessage />}
      {isLovedOnesMsg ? (
        <StyledLovedOnesModalHeader id="modal-heading">
          {formatMessage({ id: 'enterYourLovedOnesDeliveryAddress' })}
        </StyledLovedOnesModalHeader>
      ) : (
        <StyledModalHeader id="modal-heading">
          {formatMessage({ id: 'enterYourDeliveryAddress' })}
        </StyledModalHeader>
      )}
    </>
  );
};

export default DeliveryAddressFormHeader;
